
import { defineComponent, onMounted, PropType, ref, watch } from "vue";

import {
  ColumnDefinition,
  OptionType,
  FormFieldComboBox,
  BaseButton,
  DeleteIcon,
  BaseTable,
} from "@tager/admin-ui";
import { Nullable, useResource } from "@tager/admin-services";

import { moveItem } from "@/views/BasisProductForm/BasisProductForm.helpers";
import { FieldType } from "@/typings/model";
import { getFieldList } from "@/services/requests";
import { convertFieldListToOption } from "@/views/CategoryForm/components/FieldConditionTable/FieldConditionTable.helpers";
import FieldCondition from "@/views/CategoryForm/components/FieldConditionTable/FieldCondition.vue";
import { FieldConditionFormValue } from "@/views/CategoryForm/CategoryForm.helpers";

const COLUMN_DEFS: Array<ColumnDefinition> = [
  {
    id: 1,
    name: "Поле",
    field: "field",
  },
  {
    id: 2,
    name: "Условие",
    field: "condition",
  },
  {
    id: 3,
    name: "",
    field: "actions",
    style: { width: "140px", textAlign: "center", whiteSpace: "nowrap" },
    headStyle: { width: "140px", textAlign: "center" },
  },
];

type Props = Readonly<{
  productType: Nullable<OptionType<number>>;
  fieldConditions: Array<FieldConditionFormValue>;
}>;

export default defineComponent({
  name: "FieldConditionTable",
  props: {
    productType: {
      type: Object as PropType<Props["productType"]>,
      required: true,
    },
    fieldConditions: {
      type: Array as PropType<Props["fieldConditions"]>,
      required: true,
    },
  },
  components: {
    FieldCondition,
    FormFieldComboBox,
    BaseButton,
    DeleteIcon,
    BaseTable,
  },
  setup(props) {
    const [
      fetchFieldList,
      { data: fieldList, loading: isFieldListLoading, error },
    ] = useResource<Array<FieldType>>({
      fetchResource: () =>
        getFieldList(props.productType ? props.productType.value : ""),
      initialValue: [],
      resourceName: "Field list",
    });

    onMounted(() => {
      fetchFieldList();
    });

    watch(
      () => props.productType,
      () => {
        props.fieldConditions.splice(0);
        fetchFieldList();
      }
    );

    const fieldOptionList = ref<Array<OptionType<number>>>([]);

    watch(fieldList, () => {
      fieldOptionList.value = convertFieldListToOption(fieldList.value);
    });

    function removeField(rowIndex: number) {
      props.fieldConditions.splice(rowIndex, 1);
    }

    function handleClick(
      itemList: Array<{ id: Nullable<number>; name: string }>,
      itemIndex: number,
      direction: "up" | "down"
    ) {
      moveItem<{ id: Nullable<number>; name: string }>(
        itemList,
        itemIndex,
        direction
      );
    }

    function addElement() {
      props.fieldConditions.push({
        field: null,
        operator: null,
        checkbox: false,
        number: "0",
        options: [],
      });
    }

    return {
      columnDefs: COLUMN_DEFS,
      removeField,
      handleClick,
      addElement,
      fieldOptionList,
    };
  },
});
